<template>
  <div id="app">
    <div style="width: 100%;min-height: 600px;display: flex;flex-direction:column;justify-content: center;align-items: center;font-size: 28px;">
      <div class="is_loading_down">正在跳转....</div>
      <template v-if="deviceType == 'ios'">
        <a class="self_click" href="https://apps.apple.com/cn/app/id1567846331">跳转失败,点击手动跳转</a>
      </template>
      <template v-else-if="deviceType == 'android'">
        <a class="self_click" href="https://img.hatcloud.cn/20163315_1639859507856356587.apk?e=2270579061&token=WsDlLjDgtDdmtdIV5Or9qEHGB6sODAC-O3wwCqF7:zUSYH1m_YH-cOrO20DAahRScgEI=">跳转失败,点击手动跳转</a>
      </template>
      <template v-else>
        <a class="self_click" href="https://img.hatcloud.cn/20163315_1639859507856356587.apk?e=2270579061&token=WsDlLjDgtDdmtdIV5Or9qEHGB6sODAC-O3wwCqF7:zUSYH1m_YH-cOrO20DAahRScgEI=">跳转失败,点击手动跳转</a>
      </template>

      <div class="attention">注意:部分手机点击依旧无效可以尝试选择用【手机自带浏览器】打开!</div>
    </div>
  </div>
</template>


<script>
  import C from '../utils/C.js';
  export default {
    name: 'ScanEwm',
    data() {
      return C.getData_with_base({
        showData:"",
        deviceType:"",//设备类型
      })
    },
    mounted() {
      console.log("search mount")

      // let systemParam = C.getSystemInfo();
      // //打印
      // this.showData = JSON.stringify(systemParam)
      // alert(this.showData)
      //
      // if(systemParam && systemParam.deviceType){
      //   let deviceType = systemParam.deviceType
      //
      //   this.deviceType = deviceType
      //   this.showData = deviceType
      //   if(deviceType == "ios"){
      //     // //苹果手机,走底部应用宝就行
      //     // window.location.href = "https://apps.apple.com/cn/app/id1567846331";
      //     // return;
      //   }else if(deviceType == "android"){
      //     // ///浏览器类型
      //     // let getBrowserType = this.browserType()
      //     // ///判断是否是微信浏览器
      //     // var isWeixin = true;
      //     // if (getBrowserType == "weixin") {
      //     //   isWeixin = true
      //     // } else {
      //     //   isWeixin = false
      //     // }
      //     // alert("是否是微信:"+isWeixin)
      //     //直接跳转apk下载链接
      //     window.location.href = "https://img.hatcloud.cn/20163313_1639720794654748948.apk?e=2270440348&token=WsDlLjDgtDdmtdIV5Or9qEHGB6sODAC-O3wwCqF7:kyG_higlKRQmeRzrU3YhXADryy4=";
      //     return;
      //   }
      // }

      //直接跳转
      window.location.href = "https://img.hatcloud.cn/20163315_1639859507856356587.apk?e=2270579061&token=WsDlLjDgtDdmtdIV5Or9qEHGB6sODAC-O3wwCqF7:zUSYH1m_YH-cOrO20DAahRScgEI=";
    },
    methods:{
      browserType:function () {//判断页面在微信  朋友圈   qq  微博打开
        var ua = navigator.userAgent.toLowerCase();//获取判断用的对象
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
          //在微信中打开
          return 'weixin'
        }
        if (ua.match(/WeiBo/i) == "weibo") {
          //在新浪微博客户端打开
          return 'weibo'
        }
        if (ua.match(/QQ/i) == "qq") {
          //在QQ空间打开
          return 'qq'
        }
        return 'other'
      }
    },
  }
</script>


<style scoped>
  .is_loading_down{
    font-size: 18px;
    color: #D0021B;
  }

  .self_click{
    margin-top: 20px;

    color: white;
    background-color: #237ED2;

    font-size: 12px;

    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;

    border-radius: 5px;
  }

  .attention{
    margin-top: 20px;

    color: #237ED2;
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/ScanEwm.vue